export enum CreditRequestType {
  Submit = 0,
  Retrieve = 1,
  Reissue = 2,
  Update = 3,
  Upgrade = 4,
  Refresh = 5,
}

export enum CreditReportType {
  MergedCreditReport = 1,
  MortgageOnlyWithScore = 3, // Streamline
  SoftPull = 4,
}

export enum CreditVendorName {
  Merged = 'Merged',
  SoftPull = 'SoftPull',
  MortgageOnlyWithScore = 'MortgageOnlyWithScore',
  MortgageOnly = 'MortgageOnly',
}

export enum CreditRequestTypeName {
  Submit = 'Submit',
  Retrieve = 'Retrieve',
  Reissue = 'Reissue',
  Update = 'Update',
  Upgrade = 'Upgrade',
  Refresh = 'Refresh',
}

export enum CreditReportTypeName {
  Merged = 'Merged',
  MortgageOnly = 'MortgageOnly',
  MortgageOnlyWithScore = 'MortgageOnlyWithScore',
  SoftPull = 'SoftPull',
}
